import {useEffect, useRef} from 'react';
import {getRealtimeMessages, approveSystemMessage} from '../../../../../redux/realtime/realtimeActions';
import {useSelector} from 'react-redux';
import * as css from './systemMessage.css';
import {useTranslation} from 'react-i18next';
import Btn from '../../../../../component/button/btn/Btn';
import {Link, useLocation} from 'react-router-dom';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';
import {useSystemMessageFilter} from './useSystemMessageFilter';
import CustomScrollbar from '../../../../../component/customScrollbar/CustomScrollbar';
import useMobile from '../../../../../hooks/useMobile';
import useGlobalShow from '../../../../../hooks/useGlobalShow';
import useSystemMessageLink from './useSystemMessageLink';
import {logGoogleEvent} from '../../../../../utils/analytics';
import {processMessageLink} from './processMessageLink';

function SystemMessage({isPop=false, close, message, skipFilter=false}:{isPop:boolean, close?: () => void, message: TSystemMessage, skipFilter?: boolean}){
    const systemMessageXHR = useSelector((s:any) => s.realtime.getSystemMessageXHR);
    const eid = useSelector((s:any) => s.event?.eid);
    const eventType = useSelector((s:any) => s.event?.type);
    const pid = useSelector((s:any) => s.account?.pid);
    const {t} = useTranslation('realtime');
    const shouldDisplay = useSystemMessageFilter(message);
    const messageRef = useRef(null);
    const isMobile = useMobile();
    const showVideos = useGlobalShow('isOpenSupportVideos');
    const showEvents = useGlobalShow('isOpenEvents');

    useEffect(()=>{
        if(!systemMessageXHR && eid)
            getRealtimeMessages().then();
    },[]);

    const approve = (event) => {
        event.preventDefault();// Prevent the default action of the link
        if(isPop){
            logGoogleEvent('system_message_approve_click', message.smid, 'message_id', {
                button_name: 'approve_system_message',
                event_label: `message id: ${message.smid}`
            });
        }

        approveSystemMessage(message.smid);
        if(close)
            close();
    };

    // Track popup opened
    useEffect(() => {
        if(isPop){
            logGoogleEvent('system_message_open', message.smid, 'message_id', {
                popup_name: 'systemMessage',
                popup_title: t('systemMessage'),
                page_title: 'system message - הודעת מערכת',
                event_label: `message id: ${message.smid}`
            });
        }
    }, [message?.smid]);

    const {handleLinkClick} = useSystemMessageLink({
        message,
        close,
        showVideos,
        showEvents
    });
    const location = useLocation();
    
    const processedLink = processMessageLink(
        message.link,
        eid,
        pid,
        eventType,
        location.pathname
    );
        
    const isSupport = processedLink?.includes('/support');

    const btnApproved=()=>!!(isPop && message.watchRequired )&&<Btn onClick={approve} className={'white'} disabled={undefined} ><css.approved/>{t('approveView')}</Btn>;
    const isImageAndText = message.formType === 'imageAndText';
    const containerImage = !isPop && !isImageAndText && message.image ? message.image : undefined;

    if(!skipFilter && !shouldDisplay) {
        return <></>;
    }

    return (
        message?.status?
            message.title? <css.container  image={containerImage} >
                {isPop && !isMobile && <CustomScrollbar contentRef={messageRef} cssStyle={''} />}
                <css.contentWrapper ref={messageRef}>
                    {isImageAndText && message.image && <css.imageContent image={message.image} />}
                    {!isPop && <css.title>{message.title}</css.title>}
                    <css.message><p>{message.message}</p></css.message>
                </css.contentWrapper>
                <css.buttons>
                    {processedLink && !isSupport && (
                        <Link to={processedLink} data-cy="system-message-navigate-link">
                            <Btn
                                className='yellow'
                                onClick={handleLinkClick}
                                dataCy="system-message-navigate-btn"
                            >
                                {message.linkText || t('showMe')}
                            </Btn>
                        </Link>
                    )}
                    {processedLink && isSupport && (
                        <Btn
                            className='yellow'
                            onClick={handleLinkClick}
                            dataCy="system-message-navigate-btn"
                        >
                            {message.linkText || t('showMe')}
                        </Btn>
                    )}
                    {btnApproved()}
                </css.buttons>
            </css.container>
                :
                <css.container className='no-title' image={containerImage} >
                    {isImageAndText && message.image && <css.imageContent image={message.image} />}
                    <Link to={processedLink}>
                        {btnApproved()}
                    </Link>
                </css.container>

            :<></>
    );
}

export default SystemMessage;